module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-1.348685c6.png";